import React, { Component } from 'react';
import TimePath from './../components/TimePath';
import {RecentJobsContext} from '../contexts/recentJobs';

export default class Experience extends Component{

    static contextType = RecentJobsContext;
    
    state = {
        jobs:[]
    }

    // reOrderJobs = () =>{
    //     let items = this.context.jobs;
       
    //     items.map(item =>{
    //         console.log(item,'from FUNC');
    //     })
    // }

    // componentDidMount(){
    //     this.reOrderJobs()
    // }

    render(){
        let {loading,jobs} = this.context;
     
        return(
            <>
                {
                    loading ? null :  <TimePath loading={loading} jobs={jobs} />
                }
            </>
        )
    }
    
}